import { useEffect, useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import { Form } from 'react-bootstrap';
import { newFetch, POST } from '../../../../../helpers/fetch';

import AlertService from '../../../../../components/SweetAlert';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../../config/index';
import LayoutContext from '../../../../../store/Layout/contexts';
const { API_URL } = config;

const AddSite = ({ history, match: { params } }) => {
  // const { register, handleSubmit, errors } = useForm()

  const token = localStorage.getItem('token');

  const { client_id } = params;

  const [client, setClient] = useState({});
  const [name, setName] = useState('');
  const [managerName, setManagerName] = useState('');
  const [managerEmail, setManagerEmail] = useState('');
  const [managerPhoneNo, setManagerPhoneNo] = useState('');
  const [attendanceThreshold, setAttendanceThreshold] = useState(0);
  const [fillThreshold, setFillThreshold] = useState(0);
  const [attendanceInvalid, setAttendanceInvalid] = useState(false);
  const [fillInvalid, setFillInvalid] = useState(false);

  const [defaultShifts, setDefaultShifts] = useState([]);

  const [validated, setValidated] = useState(false);

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?',
      )
    ) {
      setName('');
      setManagerName('');
      setManagerEmail('');
      setManagerPhoneNo('');
      setAttendanceThreshold('');
      setFillThreshold('');
      setDefaultShifts([]);
    }
  };

  const fetchClient = async () => {
    const url = `${API_URL}/client/${client_id}`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let clientData = data.data;

        setClient(clientData);
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  const nameHandler = (e) => setName(e.target.value);
  const managerNameHandler = (e) => setManagerName(e.target.value);
  const managerEmailHandler = (e) => setManagerEmail(e.target.value);
  const managerPhoneNoHandler = (e) => setManagerPhoneNo(e.target.value);
  const attendanceThresholdHandler = (e) => {
    const value = e.target.value;
    setAttendanceThreshold(value);
    setAttendanceInvalid(!isValidThreshold(value));
  };

  const fillThresholdHandler = (e) => {
    const value = e.target.value;
    setFillThreshold(value);
    setFillInvalid(!isValidThreshold(value));
  };

  const addShifts = () =>
    setDefaultShifts([
      ...defaultShifts,
      {
        name: '',
        start_time: '',
        end_time: '',
      },
    ]);

  const removeShift = (index) =>
    setDefaultShifts([...defaultShifts].filter((shift, i) => i !== index));

  const shiftNameHandler = (e, index) => {
    const newArr = JSON.parse(JSON.stringify(defaultShifts));
    newArr[index].name = e.target.value;

    setDefaultShifts(newArr);
  };

  const shiftStartTimeHandler = (e, index) => {
    const newArr = JSON.parse(JSON.stringify(defaultShifts));
    newArr[index].start_time = e.target.value;

    setDefaultShifts(newArr);
  };

  const shiftEndTimeHandler = (e, index) => {
    const newArr = JSON.parse(JSON.stringify(defaultShifts));
    newArr[index].end_time = e.target.value;

    setDefaultShifts(newArr);
  };

  const submitSite = async () => {
    const url = `${API_URL}/client/${client_id}/site/create`;

    const data = {
      name,
      manager_name: managerName,
      manager_email: managerEmail,
      manager_phone_no: managerPhoneNo,
      attendance_threshold: attendanceThreshold,
      fill_threshold: fillThreshold,
    };

    try {
      return await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const submitShifts = async (site_id) => {
    if (defaultShifts.length > 0) {
      const create_url = `${API_URL}/site/${site_id}/shifts`;

      return await Promise.all(
        defaultShifts.map(async (shift) => {
          let data = {
            name: shift.name,
            start_time: shift.start_time,
            end_time: shift.end_time,
          };

          try {
            let response = await fetch(create_url, {
              method: 'POST',
              body: JSON.stringify(data),
              withCredentials: true,
              mode: 'cors',
              headers: {
                Authorization: token,
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json; charset=utf-8',
              },
            });

            return await response.json();
          } catch (error) {
            console.log(error);
          }
        }),
      );
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitFormHandler(event);
    }

    setValidated(true);
  };

  const isValidThreshold = (value) => {
    const num = Number(value);
    return value !== '' && !isNaN(num) && num >= 0 && num <= 100;
  };

  const submitFormHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm('', 'Are you sure you want to add this site?')
    ) {
      try {
        let site_data = {
          name,
          manager_name: managerName,
          manager_email: managerEmail,
          manager_phone_no: managerPhoneNo,
          attendance_threshold: attendanceThreshold,
          fill_threshold: fillThreshold,
        };

        let submit_site_path = `/client/${client_id}/site/create`;
        let site_response = await newFetch(POST, submit_site_path, site_data);

        if (site_response.success) {
          const site_id = site_response.data.id;

          if (defaultShifts.length > 0) {
            let shift_responses = await submitShifts(site_id);

            let shiftErr = shift_responses.find((res) => !res.success);

            if (shiftErr) {
              ToastUtil.error(
                `${site_response.message}. Shift Error: ${shiftErr.message}`,
              );
            } else {
              ToastUtil.success(site_response.message);
            }
            history.push(`/clients/client/${client_id}/sites/site/${site_id}`);
          } else {
            ToastUtil.success(site_response.message);
            history.push(`/clients/client/${client_id}/sites/site/${site_id}`);
          }
        } else {
          ToastUtil.error(site_response.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    fetchClient();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/clients/client/${client_id}`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#0d6efd' }}>
                <i className="fas fa-chevron-left pe-2"></i> {client.name}
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Add Site</h5>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Site Information</strong>
                <p className="pt-2 text-muted">Manage site's information</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row">
                  <div className="col-sm-12">
                    <strong>Site Name*</strong>
                    <input
                      required
                      name="siteName"
                      type="text"
                      // ref={register({required: true})}
                      placeholder="Site Name"
                      className="form-control mt-3"
                      value={name}
                      maxLength={255}
                      onChange={(e) => nameHandler(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter site name.
                    </Form.Control.Feedback>
                    {/* { errors.siteName && (
                                            <span className="text-danger mt-2">Site name is required</span>
                                        ) } */}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <strong>Manager Name</strong>
                    <input
                      name="managerName"
                      type="text"
                      placeholder="Manager Name"
                      className="form-control mt-3"
                      value={managerName}
                      maxLength={150}
                      onChange={(e) => managerNameHandler(e)}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <strong>Manager Email</strong>
                    <input
                      name="managerEmail"
                      type="text"
                      placeholder="Manager Email"
                      className="form-control mt-3"
                      value={managerEmail}
                      maxLength={150}
                      onChange={(e) => managerEmailHandler(e)}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <strong>Manager Contact</strong>
                    <input
                      name="managerPhoneNo"
                      type="text"
                      placeholder="Manager Contact"
                      className="form-control mt-3"
                      value={managerPhoneNo}
                      maxLength={25}
                      onChange={(e) => managerPhoneNoHandler(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Threshold</strong>
                <p className="pt-2 text-muted">
                  Manage attendance rate and fill rate threshold
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row">
                  <div className="col-sm-12">
                    <strong>Attendance rate threshold*</strong>
                    <input
                      required
                      name="attendanceThreshold"
                      type="number"
                      min={0}
                      max={100}
                      step="any"
                      placeholder="Attendance rate threshold %"
                      className={`form-control mt-3 ${
                        attendanceInvalid ? 'is-invalid' : ''
                      }`}
                      value={attendanceThreshold}
                      onChange={attendanceThresholdHandler}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a value between 0 and 100.
                    </Form.Control.Feedback>
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-sm-12">
                    <strong>Fill rate threshold*</strong>
                    <input
                      required
                      name="fillThreshold"
                      type="number"
                      min={0}
                      max={100}
                      step="any"
                      placeholder="Fill rate threshold %"
                      className={`form-control mt-3 ${
                        fillInvalid ? 'is-invalid' : ''
                      }`}
                      value={fillThreshold}
                      onChange={fillThresholdHandler}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a value between 0 and 100.
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: '6rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Default Schedule</strong>
                <p className="pt-2 text-muted">
                  Manage scheduling rules and automatic shift assignments
                </p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                {defaultShifts.map((shift, index) => (
                  <div className="pb-3" key={index}>
                    <div className="w-100 text-end pb-1">
                      <strong
                        style={{ cursor: 'pointer' }}
                        className="text-danger"
                        onClick={() => removeShift(index)}
                      >
                        <i className="fas fa-trash"></i>&nbsp;&nbsp;&nbsp;Remove
                      </strong>
                    </div>
                    <div
                      className="border rounded mb-3"
                      style={{ padding: '2.25rem' }}
                    >
                      <div className="row">
                        <div className="col-sm-4">
                          <strong>Shift Name</strong>
                          <input
                            type="text"
                            className="form-control mt-3"
                            value={shift.name}
                            maxLength={200}
                            onChange={(e) => shiftNameHandler(e, index)}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter shift name.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-sm-4">
                          <strong>Start Time</strong>
                          <input
                            type="time"
                            className="form-control mt-3"
                            value={shift.start_time}
                            onChange={(e) => shiftStartTimeHandler(e, index)}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter start time.
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-sm-4">
                          <strong>End Time</strong>
                          <input
                            type="time"
                            className="form-control mt-3"
                            value={shift.end_time}
                            onChange={(e) => shiftEndTimeHandler(e, index)}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter end time.
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div
                  onClick={() => addShifts()}
                  className="border rounded"
                  style={{
                    paddingLeft: '2.25rem',
                    paddingRight: '2.25rem',
                    paddingTop: '1.5rem',
                    paddingBottom: '1.5rem',
                    cursor: 'pointer',
                  }}
                >
                  <i className="fas fa-plus"></i>&nbsp;&nbsp;&nbsp;
                  <strong>Add New Shift</strong>
                </div>
              </div>
            </div>

            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={discardHandler}
                className="btn btn-outline-brand adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div>
          </Form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddSite);
